module.exports = __webpack_public_path__ + "img/warning.47d26b19.svg";